<template>
    <div class="project-copy-container">
        <div v-if="! loading && project_lead">
            <vue-form
                :form-config="projectCopyFormConfig"
                :form-data="project_lead"
                :auto-save="false"
                :form-submit-url="'/api/projects/' + projectId + '/copy'"
                :actions="formActions"
                @copy-project="copyProject"
            ></vue-form>
            <modal
                    v-if="showConfirmModal"
                    :is-confirm="true"
                    modal-width="500px"
                    @close="showConfirmModal = false"
                    @confirmed="runSubmission"
                    confirm-text="Copy"
            >

                <h4 slot="header">
                    {{ modalHeader}}
                </h4>

                <div slot="body" v-html="modalBody"></div>

            </modal>
        </div>
        <div v-else>
            <span class="fa fa-spinner fa-spin"></span>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState} from 'vuex';

export default {

    props: {
        projectId: {
            required: true,
            type: Number,
        },
        projectCopyFormConfig: {
            required: true,
            type: Object
        },
        modalHeader: {
            required: true,
            type: String,
        },
        modalBody: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            loading: false,
            showConfirmModal: false,
            formActions: [
                {
                    name: 'copy',
                    label: 'Copy',
                    action: 'copy-project'
                }
            ],
            project_lead: {
                program_year: null
            },
            invited_leads: null
        }
    },

    created() {
        let project = this.$store.getters['mp_layout/getProject'](this.$store.state.mp_layout.assessmentMPID);
        this.project_lead.program_year = project.program_year_id;
    },

    computed: {},

    methods: {
        copyProject(leadData) {
            this.showConfirmModal= true;
            this.project_lead = leadData;
        },
        runSubmission() {
            this.loading = true; // not really loading data, but will allow the overlay to pop up.

            axios.post(
                '/api/projects/' + this.projectId + '/copy',
                this.project_lead
            ).then( response => {
                this.loading = false;
                this.showConfirmModal = false;

                //Reset form after success
                this.project_lead.scenario_id = null;
                this.project_lead.measures_to_copy = 1;

                window.notify.message(response.data.message, 'success');

            }).catch( error => {
                window.notify.apiError(error);
                this.loading = false;
                this.showConfirmModal = false;
            })
        }
    }

}
</script>
